import { render } from "./BattlesHeaderGame.vue?vue&type=template&id=0d51f626&scoped=true"
import script from "./BattlesHeaderGame.vue?vue&type=script&lang=js"
export * from "./BattlesHeaderGame.vue?vue&type=script&lang=js"

import "./BattlesHeaderGame.vue?vue&type=style&index=0&id=0d51f626&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d51f626"]])

export default __exports__